import request from './request.js'

export default{
    //单个添加系统类型
     addSystemtypeSingle(params) {
      //对象传参：id 类型编号、name 类型名称 、description 类型描述
      return request({
        url: '/SystemType/Set',
        method: 'post',
        data: params
      });
    },
    //单个修改系统类型
    setSystemtypeSingle(params) {
      //对象传参： 系统类型DTO（查询的所有信息）
      return request({
        url: '/SystemType/Set',
        method: 'post',
        data: params
      });
    },
    //查询所有系统类型
    getSystemAll(){
      return request({
        url: '/SystemType/GetAll',   // code: 200 success
        method: 'get'
      });
    },
		// 删除所有系统类型
		deleteSystemtype(params) {
			return request({
				url:'/SystemType/Delete' + params,
				method:'post',
			});
		}
}
